import { render, staticRenderFns } from "./ConfirmationCode.vue?vue&type=template&id=2ba162cf&scoped=true&"
import script from "./ConfirmationCode.vue?vue&type=script&lang=ts&"
export * from "./ConfirmationCode.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmationCode.vue?vue&type=style&index=0&id=2ba162cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba162cf",
  null
  
)

export default component.exports